<template>
  <div class="content">
    <div class="row">
      <div class="col-8 ignore-screen">
        <h2 class="font-light">New Scanned Record</h2>
      </div>
      <div class="col-4 ignore-screen u-vertical-center u-inline-flex">
        <div class="form-group u-inline u-fill-width u-text-right">
          <a @click="$router.go(-1)" class="u-inline">
            <button class="btn-info u-pull-right">
              <i
                class="fa-wrapper fa fa-reply normal-icon pad-right"
                aria-hidden="true"
              ></i>
              Back
            </button>
          </a>
        </div>
      </div>
    </div>
    <server-error v-bind:error="error.serverError"></server-error>
    <scanned-record-form
      v-bind:data="form"
      v-on:input="updateForm"
    ></scanned-record-form>
  </div>
</template>

<style>
input[type="file"] {
    display: none;
}
</style>
/
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import ScannedRecordForm from "@/components/records/ScannedRecordForm";
import ServerError from "@/components/ServerError";
import { scrollToTop } from "@/functions/scrollToTop";

export default {
  name: "scanned-record-create",
  data: function() {
    return {
      form: {
        title: null,
        candidate: null,
        document: null,
      }
    }
  },
  components: {
    ScannedRecordForm,
    ServerError,
  },
  computed: {
    ...mapGetters("auth", ["users", "userProfile", "permissions"]),
    ...mapGetters("core", ["error"]),
  },
  methods: {
    updateForm: function(key, value) {
      Vue.set(this.form, key, value);
    }
  },
  mounted() {
    scrollToTop();
    // Handle pre-selected candidates passed through an URL query
    if (Object.keys(this.$route.query).includes("candidate")) {
      let candidate = [this.users.find(u => u.id == this.$route.query.candidate)];
      Vue.set(this.form, "candidate", candidate);
      this.$router.replace({ name: "scanned-record-create" });
    };
  }
}
</script>
